import {useState} from 'react'

import {useSelector,useDispatch} from 'react-redux'

import {
	unassignOnbardingPipeline,
	setPipelineAssignmentsEditor,
	assignOnbardingPipeline
} from '../slice'

import {
	dateToYMD
} from '../../../util/datetime'

import {
	useProspectiveClients,
	useOnboardingPipeline
} from '../hooks'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'
import Select from 'react-select'

const AssignedProspect = ({prospect})=>{
	const {id} = useSelector(state=>state.growth.pipelines.assignmentsEditor)
	const dispatch = useDispatch()
	const [isUnassigning,setIsUnassigning] = useState(false)
	const handleUnassign = ()=>{
		if(!window.confirm('Are you sure you want to unassign this automation?')) return 
		setIsUnassigning(true)
		dispatch(unassignOnbardingPipeline({
			pipeline_id:id,
			user_id_numbers:[prospect.user_id_number]
		})).then(()=>{
			setIsUnassigning(false)
		})
	}
	if (!prospect) return null
	return (
		<div 
			className="border rounded mt-2 px-2 py-1 d-flex justify-content-between align-items-center"
		>
			{prospect.user_name}
			<Button 
				disabled={isUnassigning}
				onClick={handleUnassign}
				variant="outline-danger"
				size="sm"
			>
				<i className="fa fa-trash"/> {isUnassigning&&<Spinner animation="border" size="sm"/>}
			</Button>
		</div>
	)
}

export default function PipelineAssignmentsEditor(){
	const dispatch = useDispatch()
	const {id,show} = useSelector(state=>state.growth.pipelines.assignmentsEditor)
	const {status:pipelineStatus,pipeline} = useOnboardingPipeline(id)
	const {status:prospectsStatus,entities:prospectsMap} = useProspectiveClients()


	const onHide = ()=>{
		dispatch(setPipelineAssignmentsEditor({show:false,id:null}))
	}

	const [isUnassigning,setIsUnassigning] = useState(false)

	const assignedUsers = pipeline?.users.map(u=>prospectsMap[u.user_id_number]) || []

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				Edit Automation Assignments
			</Modal.Header>
			<Modal.Body>
				{assignedUsers.length===0&&
					'This automation has not been assigned to anyone.'
				}
				{assignedUsers.map(prospect=>(
					<AssignedProspect key={prospect?.user_id_number} prospect={prospect}/>
				))}
			</Modal.Body>
		</Modal>
	)
}